import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { removeInteraction, saveInteractionsToStorage } from '../../../models/InteractionModel';


const DeleteInteractionModal = ({showModal, setShowModal, interactionData, modalKey, fetchInteractions, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [interaction_unique_id, setInteractionUniqueID] = useState('');

    const closeModal = () =>{
        setInteractionUniqueID('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (interactionData) {
            setInteractionUniqueID(interactionData.interaction_unique_id);
        }
    }, [interactionData, modalKey]);


    const deleteInteraction = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeInteraction(user_data.user_token, interaction_unique_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            saveInteractionsToStorage(response.data.interactions, response.data.pagination);
    
            fetchInteractions(limit, page); 

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Interaction</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete this interaction ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteInteraction}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteInteractionModal;